import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { Card, Col, Row } from 'antd';

const NoteItensIbtp = () => {
  return (
    <>
      <Card title="IBPT Simplificado" type="inner" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'generalIbptRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>

      <Card title="IBPT Detalhado" type="inner">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota municipal"
              name={['itemTaxes', 'municipalIbptRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota estadual"
              name={['itemTaxes', 'stateIbptRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota federal"
              name={['itemTaxes', 'federalIbptRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default NoteItensIbtp;
